/* 🤖 this file was generated by svg-to-ts*/
export const iconFemale: {
  name: 'female';
  data: string;
} = {
  name: 'female',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16"><path d="M2 5c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3m6 6H6v-1c0-.035-.017-.064-.02-.099A4.999 4.999 0 005 0a5 5 0 00-.98 9.901C4.017 9.936 4 9.965 4 10v1H2a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2"/></svg>`,
};
